import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from "@/router";
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null)
  const toast = useToast()

  const tableColumns = [
    {
      label: 'intelbras.event',
      key: 'event',
      sortable: false
    },
    {
      label: 'intelbras.zones_pgm',
      key: 'value',
      sortable: false
    },
    {
      label: 'intelbras.alarm_type_sbo',
      key: 'alarm_type',
      sortable: true
    },
    {
      label: 'intelbras.description',
      key: 'description',
      sortable: false
    },
    {
      label: 'intelbras.dispatchAlarm',
      key: 'dispatch_alarm',
      sortable: true
    },
  ]

  if (ability.can('update', 'intelbrasActions') || ability.can('delete', 'IntelbrasActions')) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('description')
  const isSortDirDesc = ref(false)
  const idPanel = router.currentRoute.params.id_panel;

  store.dispatch('type_alarm/getAll')
  store.dispatch('intelbras_events/getAll')

  const eventCode = ref([])
  const eventCodeOptions = computed(() => store.getters['intelbras_events/getSelectedItems'])

  const typeAlarm = ref([])
  const alarmTypeOptions = computed(() => store.getters['type_alarm/getSelectedItems'])

  const eventCodeFilter = ref(null)
  const typeAlarmFilter = ref(null)
  const dispatchAlarmFilter = ref(null)
  const valueFilter = ref(null)
  const idIntelbrasProfile = ref(parseInt(router.currentRoute.params.id_intelbras_profile))

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    store.dispatch('intelbras_rules/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      code: eventCodeFilter.value,
      id_type_alarm: typeAlarmFilter.value,
      id_panel: idPanel,
      dispatch_alarm: dispatchAlarmFilter.value,
      value: valueFilter.value,
      'id_intelbras_profile': idIntelbrasProfile.value
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({})
  const filtersCount = useFilterCounter(filters)

  const buildFilters = () => {
    filters.value = {
      code: eventCodeFilter.value,
      id_type_alarm: typeAlarmFilter.value,
      dispatch_alarm: dispatchAlarmFilter.value,
    }
    refetchData()
  }

  const clearSearchFilters = () => {
    eventCodeFilter.value = null
    typeAlarmFilter.value = null
    dispatchAlarmFilter.value = null
    buildFilters()
  }

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,

    idPanel,
    eventCode,
    eventCodeOptions,
    typeAlarm,
    alarmTypeOptions,
    eventCodeFilter,
    typeAlarmFilter,
    dispatchAlarmFilter,
    valueFilter,

    refetchData,
    clearSearchFilters,
    buildFilters,
    filtersCount,

    idIntelbrasProfile
  }
}
